import { CustomTableColumn } from "./custom-table-column";

export class SimpleUntranslatedTableColumn extends CustomTableColumn {
    constructor(name: string, label: string, path: string) {
        super(name, label, path);
    }
}
